"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : DROPDOWN : SINGLE SELECT : STYLES --------------- ++++++++++ */


var _default = {
  singleselectdropdown: {
    position: 'relative',
    width: (0, _index.pxToEm)(260),
    height: (0, _index.pxToEm)(48),
    zIndex: 1,
    '& .placeholder': {
      width: '100%',
      height: '100%',
      padding: (0, _index.pxToEm)(18),
      background: _index.theme.color.light.light.swatch,
      borderRadius: (0, _index.pxToEm)(4),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxShadow: _index.theme.boxShadow.small,
      cursor: 'pointer',
      border: "".concat((0, _index.pxToEm)(2), " solid transparent"),
      transition: 'border .2s linear 0s',
      '& .placeholdertext': {
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      },
      '&:hover': {
        borderColor: _index.theme.color.secondary.light.swatch
      },
      '&.active-true': {
        borderColor: _index.theme.color.primary.medium.swatch
      }
    },
    '& .name-menuItems': {
      height: 'auto',
      maxHeight: (0, _index.pxToEm)(428),
      display: 'flex',
      flexDirection: 'column',
      padding: (0, _index.replacePXinStringWithEM)('10px'),
      backgroundColor: _index.theme.color.light.light.swatch,
      boxShadow: _index.theme.boxShadow.small,
      '& .searchbar': {
        marginBottom: (0, _index.pxToEm)(7)
      },
      '& .name-items': {
        overflow: 'scroll',
        overflowX: 'hidden',
        extend: (0, _index.coloredScrollBar)(_index.theme.color.primary.medium.swatch)
      },
      '&.active-false': {
        height: (0, _index.pxToEm)(0),
        padding: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
        transition: 'all .15s',
        opacity: 0
      }
    },
    '&.disabled-true': {
      extend: _index.disable
    }
  }
};
exports.default = _default;